<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div class="row">
          <div class="col-md-3 col-12">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchFutureEmployees()" />
          </div>
          <div class="col-md-9 col-12 text-right" [ngClass.sm]="'d-none'">
            <div class="w-fit d-inline-block">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body px-0 pb-0">
        <ngx-datatable
          class="bootstrap core-bootstrap w-100"
          columnMode="force"
          [headerHeight]="50"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 70 : 200"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredFutureEmployees"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate), totalMessage: ('TOTAL' | translate).toLowerCase() }"
          [sorts]="[{ prop: 'start_date', dir: 'desc' }]"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <ng-container [ngSwitch]="row.type_code">
                <a target="_blank" *ngSwitchCase="'candidate'" [routerLink]="['/dashboard/future-employee/profile/', row.hash]">{{ row.complete_name }}</a>
                <a target="_blank" *ngSwitchCase="'collaborator'" [routerLink]="['/dashboard/collaborators/edit/', row.hash]">{{ row.complete_name }}</a>
              </ng-container>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="{{ 'START_DATE' | translate }}" prop="start_date" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.start_date| date: "dd/MM/yyyy" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'FIGURE' | translate }}" prop="figure_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.figure_name ? row.figure_name : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="{{ 'CITY' | translate }}" prop="working_city_name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.working_city_name ? row.working_city_name : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="{{ 'USER_OFFICE_EMAIL' | translate }}" prop="email_already_assigned" [sortable]="true" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ (row.email_already_assigned ? "ASSIGNED_FEMALE" : "NOT_ASSIGNED_FEMALE") | translate }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ASSETS' | translate }}" prop="has_assets" [sortable]="true" width="200" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ (row.has_assets ? "ASSIGNED" : "NOT_ASSIGNED") | translate }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false"
                                *ngIf="_authenticationService.hasCapabilities(['edit_bargaining', 'manage_assign_asset', 'assign_office_email', 'show_menu_bargaining_list']) && _utilService.isDesktop"
          >
            <ng-template ngx-datatable-cell-template let-row="row">
              <div ngbDropdown container="body">
                <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow">
                  <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                </button>
                <div ngbDropdownMenu>
                  <a ngbDropdownItem target="_blank" *ngIf="!!row.transformation_id" [routerLink]="'/dashboard/transformation-edit/' + row.transformation_id" has_capability="show_menu_transformation">
                    <span [data-feather]="'user-check'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} {{ 'TRANSFORMATION' | translate | lowercase}}
                  </a>
                  <a ngbDropdownItem target="_blank" *ngIf="!!row.bargaining_id" [routerLink]="'/dashboard/edit-bargaining/' + row.bargaining_id" has_capability="show_menu_bargaining_list">
                    <span [data-feather]="'user-check'" size="16" class="mr-50"></span> {{ "VIEW" | translate }} {{ 'BARGAINING' | translate | lowercase}}
                  </a>
                  <a ngbDropdownItem (click)="showModalAdd(row)" has_capability="manage_assign_asset">
                    <span [data-feather]="'clipboard'" size="16" class="mr-50"></span> {{ "ASSIGN_ASSET" | translate }}
                  </a>
                  <a ngbDropdownItem (click)="modalOpen(assignNewEmail, row)" has_capability="assign_office_email">
                    <span [data-feather]="'globe'" size="16" class="mr-50"></span> {{ "ASSIGN_EMAIL" | translate }}
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="firstname" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-10">
                  <a class="font-medium-1" target="_blank" routerLink="/dashboard/user/profile/{{ row.hash }}">{{ row.firstname }} {{ row.lastname }}</a>
                </div>
                <div class="col-1" ngbDropdown container="body" *ngIf="_authenticationService.hasCapabilities(['edit_bargaining', 'manage_assign_asset', 'assign_office_email', 'show_menu_bargaining_list'])">
                  <button ngbDropdownToggle type="button" class="btn icon-btn btn-sm hide-arrow">
                    <span [data-feather]="'more-vertical'" class="cursor-pointer"></span>
                  </button>
                  <div ngbDropdownMenu>
                    <a ngbDropdownItem target="_blank" has_capability="show_menu_bargaining_list" [routerLink]="row.transformation_id ? '/dashboard/transformation-edit/' + row.transformation_id : '/dashboard/edit-bargaining/' + row.bargaining_id">
                      <span [data-feather]="'user-check'" size="16" class="mr-50"></span> {{ "VIEW" | translate }}
                    </a>
                    <a ngbDropdownItem (click)="showModalAdd(row)" has_capability="manage_assign_asset">
                      <span [data-feather]="'clipboard'" size="16" class="mr-50"></span> {{ "ASSIGN_ASSET" | translate }}
                    </a>
                    <a ngbDropdownItem (click)="modalOpen(assignNewEmail, row)" has_capability="assign_office_email">
                      <span [data-feather]="'globe'" size="16" class="mr-50"></span> {{ "ASSIGN_EMAIL" | translate }}
                    </a>
                  </div>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "START_DATE" | translate }}: {{ row.start_date | date: "dd/MM/yyyy" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "FIGURE" | translate }}: {{ row.figure ? row.figure : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "CITY" | translate }}: {{ row.working_city ? row.working_city : ("FIELD_NOT_SPECIFIED_FEMALE" | translate) }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "EMAIL" | translate }}: {{ (row.email_already_assigned ? "ASSIGNED_FEMALE" : "NOT_ASSIGNED_FEMALE") | translate }}</span>
                </div>
                <div class="col-12">
                  <span class="font-medium-1">{{ "ASSETS" | translate }}: {{ (row.has_assets ? "ASSIGNED" : "NOT_ASSIGNED") | translate }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>

<!-- Modal Add Email -->
<ng-template #assignNewEmail let-modal>
  <form (ngSubmit)="assignEmail(); modal.close()">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "ASSIGN_EMAIL" | translate }}</h3>
      <label [for]="'newEmail'">{{ "EMAIL" | translate }}<sup class="text-danger">*</sup></label>
      <input [placeholder]="suggestEmail" [(ngModel)]="newEmail" name="newEmail" type="text" [id]="'newEmail'" class="form-control" />
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="modal.close('Accept click')">
        {{ "CANCEL" | translate }}
      </button>
      <button [disabled]="newEmail.length < 3" type="submit" class="btn btn-primary w-150">
        {{ "SEND" | translate }}
      </button>
    </div>
  </form>
</ng-template>
<!-- / Modal Add Email -->

<!-- Modal Assign Asset -->
<app-assets-associate-modal has_capability="manage_assign_asset" *ngIf="toggleModalAssociate" (onAssociate)="onAssociateModalFormEvent()"
                            [assetID]="AssetIdSelectedForAssociate" [employee]="selectedEmployee" [isFromFutureEmployeeList]="true" (callbackFn)="toggleModalAssociate = false"></app-assets-associate-modal>
<!-- / Modal Assign Asset -->
